(function(){
  var root=document.querySelector('[data-product]');
  if(!root)return;
  var $=function(s,c){return (c||root).querySelector(s)};
  var variants=JSON.parse($('[data-variants]').textContent);
  var form=$('[data-product-form]');
  var idInput=$('[data-variant-id]');
  var selects=form.querySelectorAll('[data-option]');
  var qty=$('[data-qty]');
  var addBtn=$('[data-add]'), addLabel=$('[data-add-label]'), nowBtn=$('[data-now]');
  var priceEl=$('[data-price]');
  var sticky=$('[data-sticky]');
  var ovSel=$('[data-vo-variant]'), ovQty=$('[data-vo-qty]');
  var cur=variants.find(function(v){return String(v.id)===idInput.value})||variants[0];

  /* header: transparent over image on mobile, solid after scrolling */
  var hw=document.getElementById('shopify-section-header');
  var hd=hw&&hw.querySelector('.header');
  function hdr(){
    if(!hd)return;
    document.documentElement.style.setProperty('--header-h',hd.offsetHeight+'px');
    hd.classList.toggle('is-scrolled',window.scrollY>10);
  }
  hdr();window.addEventListener('scroll',hdr,{passive:true});window.addEventListener('resize',hdr);

  /* gallery dots */
  var gal=$('[data-gallery]'), dots=root.querySelectorAll('[data-dots] button');
  if(gal&&dots.length){
    gal.addEventListener('scroll',function(){
      var i=Math.round(gal.scrollLeft/gal.clientWidth);
      dots.forEach(function(d,k){d.classList.toggle('is-active',k===i)});
    },{passive:true});
    dots.forEach(function(d,k){d.addEventListener('click',function(){gal.scrollTo({left:k*gal.clientWidth,behavior:'smooth'})})});
  }

  /* slides shrink slightly while swiping (peek effect) */
  if(gal&&window.innerWidth<900){
    var slides=gal.querySelectorAll('.pdp__slide');
    var tick=function(){
      var g=gal.getBoundingClientRect(),c=g.left+g.width/2;
      slides.forEach(function(sl){
        var r=sl.getBoundingClientRect(),d=Math.min(1,Math.abs(c-(r.left+r.width/2))/r.width);
        sl.style.transform='scale('+(1-0.1*d).toFixed(3)+')';
      });
    };
    gal.addEventListener('scroll',tick,{passive:true});tick();
  }

  /* quantity */
  $('[data-minus]').addEventListener('click',function(){qty.value=Math.max(1,(+qty.value||1)-1)});
  $('[data-plus]').addEventListener('click',function(){qty.value=(+qty.value||1)+1});

  /* variants */
  function priceHtml(v){return '<span>'+v.price+'</span>'+(v.compare?'<s>'+v.compare+'</s>':'')}
  function render(v){
    cur=v;
    idInput.value=v.id;
    addBtn.disabled=!v.available;nowBtn.disabled=!v.available;
    addLabel.textContent=v.available?'Add to cart':'Sold out';
    priceEl.innerHTML=priceHtml(v);
    if(sticky){
      $('[data-sticky-price]').innerHTML=v.price+(v.compare?' <s>'+v.compare+'</s>':'');
      var sv=$('[data-sticky-variant]');if(sv)sv.textContent=v.title==='Default Title'?'':v.title;
      var im=$('[data-sticky-img]');if(im&&v.image){im.src=v.image;im.removeAttribute('srcset')}
      $('[data-sticky-add]').disabled=!v.available;
    }
    if(ovSel)ovSel.value=v.id;
    var u=new URL(window.location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);
  }
  selects.forEach(function(s){s.addEventListener('change',function(){
    var chosen=Array.prototype.map.call(selects,function(x){return x.value});
    var v=variants.find(function(x){return x.options.every(function(o,i){return o===chosen[i]})});
    if(v)render(v);else{addBtn.disabled=true;nowBtn.disabled=true;addLabel.textContent='Unavailable'}
  })});
  if(ovSel)ovSel.addEventListener('change',function(){
    var v=variants.find(function(x){return String(x.id)===ovSel.value});
    if(!v)return;
    selects.forEach(function(s,i){s.value=v.options[i]});
    render(v);
  });

  /* add to cart (ajax) */
  function cartCount(n){
    var a=document.querySelector('.cart-link');if(!a)return;
    var b=a.querySelector('.cart-count');
    if(!b){b=document.createElement('span');b.className='cart-count';a.appendChild(b)}
    b.textContent=n;
  }
  function add(id,q,btn,label,done){
    var old=label?label.textContent:'';
    btn.disabled=true;
    fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+id,quantity:+q||1}]})})
      .then(function(r){if(!r.ok)throw new Error('add failed');return r.json()})
      .then(function(){return fetch(root.dataset.cartUrl).then(function(r){return r.json()})})
      .then(function(c){cartCount(c.item_count);if(label)label.textContent='Added \u2713';if(done)done()})
      .catch(function(){if(label)label.textContent='Try again'})
      .then(function(){setTimeout(function(){btn.disabled=!cur.available;if(label)label.textContent=old||'Add to cart'},1600)});
  }
  form.addEventListener('submit',function(e){
    if(e.submitter&&e.submitter.name==='checkout')return;
    e.preventDefault();add(idInput.value,qty.value,addBtn,addLabel);
  });
  var sAdd=$('[data-sticky-add]');
  if(sAdd)sAdd.addEventListener('click',function(){add(cur.id,qty.value,sAdd,null)});

  /* sticky bar appears after the main button scrolls away */
  if(sticky&&'IntersectionObserver' in window){
    new IntersectionObserver(function(en){
      var e=en[0];sticky.classList.toggle('is-visible',!e.isIntersecting&&e.boundingClientRect.top<0);
    }).observe(addBtn);
  }

  /* size chart */
  var dlg=$('[data-size-dialog]');
  if(dlg){
    $('[data-size-open]').addEventListener('click',function(){dlg.showModal()});
    $('[data-size-close]').addEventListener('click',function(){dlg.close()});
    dlg.addEventListener('click',function(e){if(e.target===dlg)dlg.close()});
  }

  /* floating video */
  var vw=$('[data-vw]'), vo=$('[data-vo]');
  if(vw&&vo){
    var vid=$('[data-vo-video]'), muteBtn=$('[data-vo-mute]'), waves=$('[data-vo-waves]');
    function open(){
      if(!vid.src)vid.src=vo.dataset.src;
      vo.hidden=false;document.body.style.overflow='hidden';
      vid.muted=false;waves.style.display='';
      var p=vid.play();if(p&&p.catch)p.catch(function(){vid.muted=true;waves.style.display='none';vid.play()});
    }
    function close(){vid.pause();vo.hidden=true;document.body.style.overflow=''}
    vw.addEventListener('click',open);
    $('[data-vo-close]').addEventListener('click',close);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!vo.hidden)close()});
    muteBtn.addEventListener('click',function(){vid.muted=!vid.muted;waves.style.display=vid.muted?'none':''});
    var ovAdd=$('[data-vo-add]');
    ovAdd.addEventListener('click',function(){add(cur.id,ovQty.value,ovAdd,ovAdd,close)});
  }
})();
